import React, { createContext, useContext, useState } from 'react';

const GalleryContext = createContext();

export const useGallery = () => {
  const context = useContext(GalleryContext);
  if (!context) {
    throw new Error('useGallery must be used within a GalleryProvider');
  }
  return context;
};

export const GalleryProvider = ({ children }) => {
  const [artworks, setArtworks] = useState([]);
  const [exhibitions] = useState([]);
  const [categories] = useState([]);
  const [loading] = useState(false);
  const [filters, setFilters] = useState({
    category: 'all',
    search: '',
    sortBy: 'title'
  });

  const addArtwork = (artwork) => {
    setArtworks(prev => [...prev, { ...artwork, id: Date.now() }]);
  };

  const updateArtwork = (id, updates) => {
    setArtworks(prev => 
      prev.map(artwork => 
        artwork.id === id ? { ...artwork, ...updates } : artwork
      )
    );
  };

  const deleteArtwork = (id) => {
    setArtworks(prev => prev.filter(artwork => artwork.id !== id));
  };

  const updateFilters = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };

  const getFilteredArtworks = () => {
    return artworks.filter(artwork => {
      const matchesCategory = filters.category === 'all' || artwork.category === filters.category;
      const matchesSearch = artwork.title.toLowerCase().includes(filters.search.toLowerCase()) ||
                           artwork.artist.toLowerCase().includes(filters.search.toLowerCase());
      return matchesCategory && matchesSearch;
    });
  };

  const value = {
    artworks,
    exhibitions,
    categories,
    loading,
    filters,
    addArtwork,
    updateArtwork,
    deleteArtwork,
    updateFilters,
    getFilteredArtworks
  };

  return (
    <GalleryContext.Provider value={value}>
      {children}
    </GalleryContext.Provider>
  );
};